<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'nivelDificuldade',
	title: 'Nível de dificuldade'
}
</script>

<style scoped>
</style>
